export default __webpack_public_path__ + "static/media/Scope-5.fc9790ab.png";